// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Footer{width:100%;height:55vh;font-size:10.5rem;background-color:#f98664;position:relative}.Footer:after{background:linear-gradient(-45deg, #f98664 50px, transparent 0),linear-gradient(45deg, #f98664 50px, transparent 0);background-position:left-bottom;background-repeat:repeat-x;background-size:100px 80px;content:' ';display:block;position:absolute;top:-70px;left:0;width:100%;height:100px}\n", ""]);
// Exports
module.exports = exports;
